import { DialogTitle } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { materialBusiness } from "api/bussiness/material/material-bussiness";
import { invalidateMaterialCatalogCache } from "api/cached";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { IAddMaterial } from "mobx-stores/_models/material-inventory/material";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DialogComplexContent } from "share-components/templates/form/dialog-complex-form/dialog-complex-content";
import { DialogComplexFormContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getAddMaterialSchema } from "./schema";

export const AddMaterial = observer(() => {
  const queryClient = useQueryClient();
  const {
    materialStore: { openNew, getMaterials, setProp },
  } = useStores();
  const {
    form: { controls, isValid },
    submitHandler,
  } = useForm<IAddMaterial>(getAddMaterialSchema(), {
    code: "",
    barcode: "",
    name: "",
    specificationLength: 0,
    specificationSize: 0,
    specificationThick: 0,
    type: "",
    allowedInventory: "",
  });

  const saveHandler = useCallback(
    async (data: IAddMaterial) => {
      try {
        await materialBusiness.add(data);
        await invalidateMaterialCatalogCache(queryClient);
        await getMaterials();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getMaterials, queryClient, setProp],
  );

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm vật tư</DialogTitle>
      <DialogComplexContent>
        <DialogComplexFormContainer>
          <DynamicForm controls={controls}></DynamicForm>
        </DialogComplexFormContainer>
      </DialogComplexContent>
    </DialogForm>
  );
});
